<template>
  <v-container class="pa-0">
    <v-row>
      <v-col cols="12" md="6">
        <h2 class="title text_color">
          Pending triggers
        </h2>
      </v-col>
      <v-col cols="12">
        <v-card class="px-4 custom_card">
          <v-row no-gutters class="mt-6">
            <v-col cols="12" md="4" class="mr-2">
              <v-text-field
                v-model="triggersTable.filters.search"
                dense
                outlined
                clearable
                prepend-inner-icon="search"
                :label="$t('actions.search')"
                class="rounded-lg font-weight-regular"
                @keyup.enter="fetchTriggers"
                @click:clear="clearSearch"
              />
            </v-col>
            <v-col cols="12" md="4" class="ml-2">
              <v-select
                v-model="triggersTable.filters.status"
                :items="triggerStatuses"
                :label="$t('common.status')"
                item-text="text"
                item-value="value"
                dense
                outlined
                clearable
                class="rounded-lg font-weight-regular"
                @click:clear="clearSearch"
                @change="fetchTriggers"
              />
            </v-col>
            <v-col cols="12">
              <v-data-table
                :loading="triggersTable.loading"
                :items="triggersTable.items"
                :server-items-length="triggersTable.total"
                :items-per-page="triggersTable.pagination.itemsPerPage"
                :headers="triggersTable.headers"
                :footer-props="{ 'items-per-page-options': [10, 20, 50, 100] }"
                @update:options="triggersTable.pagination = $event"
              >
                <template v-slot:item.createdAt="{ item }">
                  <span>
                    {{ item.createdAt | moment('LL') }}
                  </span>
                </template>
                <template v-slot:item.actions="{ item }">
                  <div class="d-flex" style="gap:4px">
                    <v-btn icon>
                      <v-icon>
                        visibility
                      </v-icon>
                    </v-btn>
                    <v-btn icon @click="sendTrigger(item)">
                      <v-icon class="mb-1">
                        ios_share
                      </v-icon>
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from 'vue'
import { triggersService } from '../../services/triggers.service'

export default {
  name: 'Triggers',
  data () {
    return {
      triggersTable: {
        loading: false,
        items: [],
        total: 0,
        pagination: {
          itemsPerPage: 10,
          page: 1
        },
        filters: {
          search: null,
          status: null
        },
        headers: [
          {
            text: 'ID',
            align: 'start',
            value: 'id',
            sortable: true,
            class: 'header_color'
          },
          {
            text: 'Status',
            align: 'start',
            value: 'status',
            sortable: false,
            class: 'header_color'
          },
          {
            text: 'Reference',
            align: 'start',
            value: 'referenceTable',
            sortable: false,
            class: 'header_color'
          },
          {
            text: 'Reference ID',
            value: 'referenceId',
            sortable: false,
            class: 'header_color'
          },
          {
            text: 'Date',
            value: 'createdAt',
            sortable: true,
            class: 'header_color'
          },
          {
            text: 'Actions',
            value: 'actions',
            sortable: false,
            class: 'header_color'
          }
        ]
      },
      triggerStatuses: [
        {
          text: 'STARTING',
          value: 1
        },
        {
          text: 'PROCESSING',
          value: 2
        },
        {
          text: 'COMPLETED',
          value: 3
        },
        {
          text: 'ERRORS',
          value: 4
        }
      ]
    }
  },
  watch: {
    'triggersTable.pagination': {
      async handler () {
        await this.fetchTriggers()
      },
      deep: true
    }
  },
  methods: {
    async fetchTriggers () {
      const { triggersTable } = this
      const { pagination, filters } = triggersTable

      try {
        const payload = {
          page: pagination.page,
          limit: pagination.itemsPerPage,
          search: filters.search,
          status: filters.status
        }

        triggersTable.loading = true

        const response = await triggersService.fetchTriggers(payload)

        triggersTable.items = response.items
        triggersTable.total = parseInt(response.total, 10)
      } catch (error) {
        console.error(error)
      } finally {
        triggersTable.loading = false
      }
    },
    async sendTrigger (item) {
      try {
        const response = await triggersService.sendTrigger(item.id)

        if (!response || !response.success) {
          throw new Error('An error occurred while sending the trigger')
        }

        await this.sleep(1000)

        this.triggersTable.filters.status = null

        await this.fetchTriggers()
        Vue.noty.success('Trigger sent to process successfully')
      } catch (error) {
        Vue.noty.error('An error occurred while sending the trigger')
      }
    },
    async clearSearch () {
      this.triggersTable.filters.search = null
      await this.fetchTriggers()
    },
    async sleep (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}
</script>

<style lang="scss">
.custom_card {
  border-radius: 12px !important;
  border: 1px solid #d0d3db !important;
}
.text_color {
  color: #344054 !important;
}

.header_color {
  color: #2661ff !important;
}
</style>
